import React from "react";
import CommonSendComponent from "../../components/CommonSendComponent";
import Menu from "../Menu";
import { SEND_CONFIGS } from "../../config/sendConfigs";

const SendHtmlDocZip = () => {
  return (
    <>
      <Menu />
      <CommonSendComponent config={SEND_CONFIGS.htmlDocZip} />
    </>
  );
};

export default SendHtmlDocZip;
